import React, {useEffect, useRef, useState} from 'react';
import BtnSearchDetail from "../../components/buttons/BtnSearchDetail";
import SearchDetailDrawer from "./SearchDetailDrawer";
import {isMobile, nonObject, toKSTISOString, toKSTISOStringEnd} from "../commonmethod/CommonMethod";
import TableSizeSelector from "../select/TableSizeSelector";
import SearchText from "../input/SearchText";
import SimmsDatePicker from "../datepicker/SimmsDatePicker";
import dayjs from "dayjs";
import {RotateCcw} from "lucide-react";
import "./searchBar.css";


function Search({ children, searchConditions, searchBar, size, detail, date, handleSearch, handlePageSizeChange, refresh, pageInfo, entity, leading, trailing} ) {
    const [isDetailOpen, setIsDetailOpen] = useState(false);
    const [selected, setSelected] = useState({});
    const [value, setValue] = useState([]);
    const prevSelectedRef = useRef(selected);
    const detailButtonRef = useRef(null);

    useEffect(() => {
        const selectedValues = {};

        React.Children.forEach(children, (child) => {
            if (value.find(e=>e.value!=null)) {
                const valueArray = value.map(e => e.value?.id);
                selectedValues.value =valueArray;
            }
        });

        setSelected(selectedValues);
    }, [value]);

    // 검색 조건이 변경될 때 handleSearch 호출
    useEffect(() => {
        if (JSON.stringify(prevSelectedRef.current) !== JSON.stringify(selected)) {
            if (handleSearch) {
                const searchParams = {
                    ...selected,
                };
                handleSearch(searchParams);
            }
            prevSelectedRef.current = selected;
        }
    }, [selected]);

    const childrenWithProps = React.Children.map(children, child => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { setter: child.subElement ? setValue : setSelected , selected:child.subElement ? value: selected, value:value, setValue:setValue});
        }
        return child;
    });


    const handleDateChange = (target, value) => {
        searchConditions[target] = value != null ? (target === "startDate" ? toKSTISOString(value) : toKSTISOStringEnd(value)) : value;
        handleSearch(searchConditions);
    };

    const resetSearch =()=>{
        window.dispatchEvent(new CustomEvent("simms:reset-drawers"));
        refresh();
    }

    const dateRangeEl = date ? (
        <div className="search-date-range">
            <SimmsDatePicker
                onChange={(v)=>nonObject(searchConditions, v, handleSearch, "startDate")}
                data={date.startDate}
                constraint={{lessThan : date.endDate && dayjs(date.endDate)}} auth />
            <span className="search-date-range-sep">~</span>
            <SimmsDatePicker
                onChange={(v)=>nonObject(searchConditions, v, handleSearch, "endDate")}
                data={date.endDate}
                constraint={{largerThan : date.startDate && dayjs(date.startDate)}} auth />
        </div>
    ) : null;

    const resetEl = refresh ? (
        <button
            type="button"
            className="search-reset-btn"
            title="검색조건 초기화"
            aria-label="검색조건 초기화"
            onClick={() => resetSearch(entity)}
        >
            <RotateCcw size={15} strokeWidth={2} aria-hidden="true" />
        </button>
    ) : null;

    const rowClassName = isMobile ? "search-row search-row--mobile" : "flex search search-row";

    const keywordRowContent = (
        <>
            {leading}
            {searchBar && <SearchText  placeHolder={searchBar?.placeHolder} value={searchConditions} title={searchBar?.title} handleSearch={handleSearch}/> }
            {size && !isMobile && <TableSizeSelector handlePageSizeChange={handlePageSizeChange} pageInfo={pageInfo} /> }
            {detail && <BtnSearchDetail isDetailOpen={isDetailOpen} setIsDetailOpen={setIsDetailOpen}  detailButtonRef={detailButtonRef}/> }
            {!isMobile && dateRangeEl}
            {!isMobile && resetEl}
            {trailing ? <div className="search-row__trailing">{trailing}</div> : null}
        </>
    );
    
    return (
        <div className="relative search-bar-root min-h-8 overflow-visible">
        <div className="search-compo">
            <div className={rowClassName}>
                {isMobile && (dateRangeEl || resetEl) ? (
                    <div className="search-mobile-date-row">
                        {dateRangeEl}
                        {resetEl}
                    </div>
                ) : null}
                {isMobile ? (
                    <div className="search-mobile-keyword-row">{keywordRowContent}</div>
                ) : (
                    keywordRowContent
                )}
            </div>
        </div>

            {detail &&
                <SearchDetailDrawer open={isDetailOpen} onClose={() => setIsDetailOpen(false)}>
                    {childrenWithProps}
                </SearchDetailDrawer>
            }
        </div>
    );
}

export default Search;